import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from "../../context/UserContext";

export default function AuthOptions() {
    const { userData, setUserData } = useContext(UserContext);
    const history = useNavigate();

    const forms = () => {
        history('/admin/form');
    };
    const bets = () => {
        history('/admin/bets');
    };
    const register = () => {
        history('/admin/register');
    };
    
    const login = () => history('/admin/login');
    const logout = () => {
        setUserData({
            token: undefined,
            user: undefined,
        });
        localStorage.setItem("auth-token", "");
        history('/admin/login');
    };

    return (
        <nav className="auth-options">
            {
                userData.user ? (
                    <>
                        {userData?.user?.role === 'consulta' || userData?.user?.role === 'administrador' ? (<button onClick={forms}>Formularios</button>) : ''}
                        {userData?.user?.role === 'loterias' || userData?.user?.role === 'administrador' ? (<button onClick={bets}>Loterías</button>) : ''}
                        <button onClick={register}>Usuarios</button>                        
                        <button onClick={logout}>Log out</button>
                    </>
                ):(
                    <>
                        <button onClick={login}>Log in</button>
                    </>
                )
            }
        </nav>
    )
}
